import { render } from "./ComingSoon.vue?vue&type=template&id=8e160860&ts=true"
import script from "./ComingSoon.vue?vue&type=script&lang=ts"
export * from "./ComingSoon.vue?vue&type=script&lang=ts"

import "./ComingSoon.vue?vue&type=style&index=0&id=8e160860&lang=css"

import exportComponent from "C:\\Users\\manya\\Documents\\Development\\Production\\Vue\\bbf-africa-website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__